import Translate from "utils/Translate";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";

const ContentExtraSmall = (props) => {
    const { styleGuide } = useContext(AppContext)
    const contentExtraSmallStyle = {
      fontFamily: styleGuide.secondaryFontFamily,
      fontWeight: styleGuide.contentExtraSmallFontWeight,
      fontSize: styleGuide.contentExtraSmallFontSize,
      fontStyle: 'normal',
      lineHeight: styleGuide.contentExtraSmallLineHeight,
      color: styleGuide.color7
    }
  
    return (
      <span onClick={props.onClick} style={{...contentExtraSmallStyle, ...props.style}} className={props.className}>
        {props.configuredLabel ? <span>{props.configuredLabel}</span> : <Translate renderHtml={props.renderHtml || false} translationKey={props.translationKey}>{props.fallbackText || props.children}</Translate>}
      </span>
    )
}

export default ContentExtraSmall;